import { DOCUMENT } from '@angular/common';
import { stringify } from '@angular/compiler/src/util';
import { ElementRef } from '@angular/core';
import { AfterViewInit, Inject } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MasterRolePermission } from '../Models/master-role-permission';


@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css']
})
export class IndexComponent implements OnInit, AfterViewInit {

  constructor(@Inject(DOCUMENT) private document, private elementRef: ElementRef, private router: Router) { }
  LiveViewParkfly: MasterRolePermission = MasterRolePermission.LiveViewParkfly;
  ViewAlarmMonitor: MasterRolePermission = MasterRolePermission.ViewAlarmMonitor;
  ViewOccupancy: MasterRolePermission = MasterRolePermission.ViewOccupancy;
  ViewParkingStations: MasterRolePermission = MasterRolePermission.ViewParkingStations;
  ViewFastagReconciliations: MasterRolePermission = MasterRolePermission.ViewFastagReconciliations;
  ViewANPRViewStreaming: MasterRolePermission = MasterRolePermission.ViewANPRViewStreaming;
  ViewGeolocalization: MasterRolePermission = MasterRolePermission.ViewGeolocalization;

  ViewReportCreate: MasterRolePermission = MasterRolePermission.ViewReportCreate;
  ViewRepository: MasterRolePermission = MasterRolePermission.ViewRepository;
  ViewScheduling: MasterRolePermission = MasterRolePermission.ViewScheduling;

  ViewCustomers: MasterRolePermission = MasterRolePermission.ViewCustomers;
  ManageCustomers: MasterRolePermission = MasterRolePermission.ManageCustomers;
  ViewProductProfiles: MasterRolePermission = MasterRolePermission.ViewProductProfiles;
  ManageProductProfiles: MasterRolePermission = MasterRolePermission.ManageProductProfiles;
  ViewTimeSlots: MasterRolePermission = MasterRolePermission.ViewTimeSlots;
  ManageTimeSlots: MasterRolePermission = MasterRolePermission.ManageTimeSlots;
  ViewGroup: MasterRolePermission = MasterRolePermission.ViewGroup;
  ManageGroup: MasterRolePermission = MasterRolePermission.ManageGroup;
  ViewRates: MasterRolePermission = MasterRolePermission.ViewRates;
  ManageRates: MasterRolePermission = MasterRolePermission.ManageRates;
  ViewAccessPolicies: MasterRolePermission = MasterRolePermission.ViewAccessPolicies;
  ManageAccessPolicies: MasterRolePermission = MasterRolePermission.ManageAccessPolicies;
  ViewBusinessCustomer: MasterRolePermission = MasterRolePermission.ViewBusinessCustomer;
  ManageBusinessCustomer: MasterRolePermission = MasterRolePermission.ManageBusinessCustomer;
  ViewRatesProfile: MasterRolePermission = MasterRolePermission.ViewRatesProfile;
  ManageRatesProfile: MasterRolePermission = MasterRolePermission.ManageRatesProfile;
  ViewUserCategory: MasterRolePermission = MasterRolePermission.ViewUserCategory;
  ManageUserCategory: MasterRolePermission = MasterRolePermission.ManageUserCategory;
  ViewCardPool: MasterRolePermission = MasterRolePermission.ViewCardPool;
  ManageCardPool: MasterRolePermission = MasterRolePermission.ManageCardPool;
  ViewVoucher: MasterRolePermission = MasterRolePermission.ViewVoucher;
  ManageVoucher: MasterRolePermission = MasterRolePermission.ManageVoucher;
  ViewDiscount: MasterRolePermission = MasterRolePermission.ViewDiscount;
  ManageDiscount: MasterRolePermission = MasterRolePermission.ManageDiscount;
  ViewOnlineBooking: MasterRolePermission = MasterRolePermission.ViewOnlineBooking;
  ManageOnlineBooking: MasterRolePermission = MasterRolePermission.ManageOnlineBooking;
  ViewAlerts: MasterRolePermission = MasterRolePermission.ViewAlerts;
  ManageAlerts: MasterRolePermission = MasterRolePermission.ManageAlerts;
  ViewParksFly: MasterRolePermission = MasterRolePermission.ViewParksFly;
  ManageParksFly: MasterRolePermission = MasterRolePermission.ManageParksFly;
  ViewBlackListWhiteList: MasterRolePermission = MasterRolePermission.ViewBlackListWhiteList;
  ManageBlackListWhiteList: MasterRolePermission = MasterRolePermission.ManageBlackListWhiteList;
  ViewStationGroup: MasterRolePermission = MasterRolePermission.ViewStationGroup;
  ManageStationGroup: MasterRolePermission = MasterRolePermission.ManageStationGroup;

  ViewSystem: MasterRolePermission = MasterRolePermission.ViewSystem;
  ManageSystem: MasterRolePermission = MasterRolePermission.ManageSystem;
  ViewLogs: MasterRolePermission = MasterRolePermission.ViewLogs;
  ManageLogs: MasterRolePermission = MasterRolePermission.ManageLogs;
  ViewAreaCount: MasterRolePermission = MasterRolePermission.ViewAreaCount;
  ManageAreaCount: MasterRolePermission = MasterRolePermission.ManageAreaCount;
  ViewDevices: MasterRolePermission = MasterRolePermission.ViewDevices;
  ManageDevices: MasterRolePermission = MasterRolePermission.ManageDevices;
  ViewUserOperators: MasterRolePermission = MasterRolePermission.ViewUserOperators;
  ManageUserOperators: MasterRolePermission = MasterRolePermission.ManageUserOperators;

  ViewAccount: MasterRolePermission = MasterRolePermission.ViewAccount;
  ManageAccount: MasterRolePermission = MasterRolePermission.ManageAccount;
  ViewContracts: MasterRolePermission = MasterRolePermission.ViewContracts;
  ManageContracts: MasterRolePermission = MasterRolePermission.ManageContracts;
  ViewRoles: MasterRolePermission = MasterRolePermission.ViewRoles;
  ManageRoles: MasterRolePermission = MasterRolePermission.ManageRoles;

  ViewCabGroup: MasterRolePermission = MasterRolePermission.ViewCabGroup;
  ManageCabGroup: MasterRolePermission = MasterRolePermission.ManageCabGroup;
  ViewTestPage: MasterRolePermission = MasterRolePermission.ViewTestPage;

  ViewCabCards: MasterRolePermission = MasterRolePermission.ViewCabCards;
  ManageCabCards: MasterRolePermission = MasterRolePermission.ManageCabCards;

  ViewLogFileCnvrtCSV: MasterRolePermission = MasterRolePermission.ViewLogFileCnvrtCSV;
  ManageLogFileCnvrtCSV: MasterRolePermission = MasterRolePermission.ManageLogFileCnvrtCSV;

  PASSWORD_WILL_EXPIRE: string = '';

  ngOnInit(): void {
    var token = sessionStorage.getItem('token');
    if (token == null) {
      this.router.navigateByUrl('/');
      return;
    }
    if (parseInt(sessionStorage.getItem('EXPIRY_COUNT')) <= 5) {
      this.PASSWORD_WILL_EXPIRE = 'Password will expiry in ' + sessionStorage.getItem('EXPIRY_COUNT') + ' Days';
    }
  }
  ngAfterViewInit() {

    const s1 = this.document.createElement('script');
    s1.type = 'text/javascript';
    s1.src = 'assets/js/custom.js';
    const __this = this; //to store the current instance to call 
    //afterScriptAdded function on onload event of 
    //script.
    s1.onload = function () { __this.afterScriptAdded(); };
    this.elementRef.nativeElement.appendChild(s1);
  }
  afterScriptAdded() {
    // const params= {
    //   width: '350px',
    //   height: '420px',
    // };
    // if (typeof (window['functionFromExternalScript']) === 'function') {
    //   window['functionFromExternalScript'](params);
    // }
  }

  HasViewPermission(name: string) {
    return sessionStorage.getItem("ROLE_PERMISSIONS").toString().indexOf(name) >= 0;
  }
}
